import React from 'react'
import PropTypes from 'prop-types'
import {
  isK5Url,
  isK5Dashboard,
  isMiddleSchoolUrl,
  isMiddleSchoolDashboard,
} from 'utils/productHelpers'
import CoursePreviewBanner from './component'

export function extractLessonsLink(text) {
  return text.match(/^(.*?)<0>(.*?)<\/0>(.*?)$/)
}

const CoursePreviewBannerContainer = ({
  customTopMargin,
  isTraining = false,
  lessonsLink,
}) => {
  // Determine the correct link for training state
  const getTrainingLink = () => {
    if (!isTraining) return lessonsLink

    // Check if it's elementary or middle school context
    const isElementary = isK5Url() || isK5Dashboard()
    const isMiddleSchool = isMiddleSchoolUrl() || isMiddleSchoolDashboard()

    if (isElementary) {
      return '/dashboard/grades-k-5'
    } else if (isMiddleSchool) {
      return '/dashboard/grades-6-8'
    }

    // Default fallback (shouldn't happen but safety net)
    return lessonsLink || '/dashboard/grades-6-8'
  }

  return (
    <CoursePreviewBanner
      customTopMargin={customTopMargin}
      extractLessonsLink={extractLessonsLink}
      isTraining={isTraining}
      lessonsLink={getTrainingLink()}
    />
  )
}

CoursePreviewBannerContainer.propTypes = {
  customTopMargin: PropTypes.string,
  isTraining: PropTypes.bool,
  lessonsLink: PropTypes.string,
}

export default CoursePreviewBannerContainer
